import React from 'react';
import styles from './wrapper.module.css';

export const PageContentWrapper = ({ children }) => {
  return <div className={styles.pageContent}>{children}</div>;
};
